module.exports = ".search-form {\r\n    width: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout-logged-in/layout-logged-in.component.css
// module id = ./src/app/layout-logged-in/layout-logged-in.component.css
// module chunks = main